"use strict";
import { tns } from "tiny-slider";

export default function () {
    if (window.innerWidth < 1024) {
        const valid = document.querySelector(".o-who-does-people__container");
        if (valid) {
            const slider = tns({
                container: ".o-who-does-people__container",
                slideBy: 1,
                controls: false,
                nav: false,
                gutter: 12,
                loop: true,
                items: 1,
                touch: true,
                mouseDrag: true,
            });

            const arrowLeft = document.querySelector(
                ".o-who-does .arrows-left"
            );
            arrowLeft.addEventListener("click", () => {
                slider.goTo("prev");
            });
            const arrowRight = document.querySelector(
                ".o-who-does .arrows-right"
            );
            arrowRight.addEventListener("click", () => {
                slider.goTo("next");
            });
        }
    }
}
